import { AuthContext } from 'contexts/AuthContext'
import { useContext } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { RouteNamesAuth } from './enum'

export const NoAuthRoutes = () => {
  const { isSignedIn } = useContext(AuthContext)
  const location = useLocation()

  return !isSignedIn ? (
    <Outlet />
  ) : (
    <Navigate
      to={RouteNamesAuth.DASHBOARD}
      replace
      state={{ from: location }}
    />
  )
}
